;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  // scripts for community page and modules found on community pages
  eah.communitySpecial = (function () {
    const initialize = function () {
      var $form = $('.interest-list__form')
      if ($form.length) {
        $('.interest-list__button:not(.js-openConciergeForm)').click(function (e) {
          const $el = $(e.target)
          if ($el.attr('href') === '#') {
            e.preventDefault()
            $form.slideToggle()
          }
        })

        $(window).on('load', function () {
          if (window.location.hash && window.location.hash === '#openform') {
            $form.slideDown()
          }
        })
      }

      // Add a resize event if
      if ($('.landing-page--special').length) {
        // $(window).resize(function () {
        //
        //   //At 940, it's 282 + 376 + 282.
        //   //At 1248, it's 374 + 500 + 374.
        //   // Only recalculate when the nav isn't floating.
        //   var sideLength = ($(window).width() - $('.masthead-image-center').width()) / 2;
        //   // $('.masthead-image-left, .masthead-image-right').width(sideLength);
        //   //$('.interest-form-wrapper').width(Math.min(940,$(window).width()));
        // });

        // var sideLength = ($(window).width() - $('.masthead-image-center').width()) / 2;
        // $('.masthead-image-left, .masthead-image-right').width(sideLength);
        // $('.interest-form-wrapper').width(Math.min(940,$(window).width()));

        $('.interest-button').click(function (e) {
          const $el = $(e.target)
          if ($el.attr('href') === '#') {
            e.preventDefault()
            $('.interest-form-wrapper').slideToggle()
          }
        })

        $('.interest-list__button:not(.js-openConciergeForm)').click(function (e) {
          const $el = $(e.target)
          if ($el.attr('href') === '#') {
            e.preventDefault()
            $('.interest-list__form').slideToggle()
          }
        })

        $(window).on('load', function () {
          if (window.location.hash && window.location.hash === '#openform') {
            $('.interest-form-wrapper').slideDown()
          }
        })
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.communitySpecial.initialize()
  })
}(jQuery, window))
